import { HoverableLink, HoverableLinkProps } from '@paywithextend/components'
import React from 'react'
import useAnalyticsContext from 'src/analytics/useAnalyticsContext'
import { useTranslate } from 'src/localization/Trns'
import { Userpilot } from 'userpilot'

type ResourceCenterAnalyticsProps = {
  event: string
  properties?: Record<string, unknown>
}

type ResourceCenterLinkProps = Omit<
  HoverableLinkProps,
  'href' | 'ariaLabelSource' | 'ariaLabel'
> & {
  analytics?: ResourceCenterAnalyticsProps
}

const ResourceCenterLink: React.FC<
  React.PropsWithChildren<ResourceCenterLinkProps>
> = (props): React.ReactElement => {
  const translate = useTranslate()

  const { analytics } = useAnalyticsContext()
  return (
    <HoverableLink
      {...props}
      // Keep the regular weight across normal + hover (HoverableLink would
      // otherwise render medium on hover, shifting the trailing sentence).
      regular
      onClick={(): void => {
        Userpilot.trigger('resource_center:jNfDAOvnub')
        if (props.analytics) {
          analytics.track(props.analytics.event, props.analytics.properties)
        }
      }}
      ariaLabelSource={'Resource Center'}
    >
      {props.children || translate('Resource Center')}
    </HoverableLink>
  )
}

export default ResourceCenterLink
